import React from 'react';
import { motion } from "motion/react";
import { ArrowRightIcon } from './Icons';

interface SubmitButtonProps {
  isSubmitting: boolean;
  text?: string;
  loadingText?: string;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ 
  isSubmitting, 
  text = "Create Account", 
  loadingText = "Creating Account..." 
}) => {
  const buttonVariants = {
    hover: { scale: 1.02 },
    tap: { scale: 0.98 },
    disabled: { scale: 1, opacity: 0.7 }
  };

  return (
    <motion.button
      type="submit"
      disabled={isSubmitting}
      className="group w-full bg-white text-black py-3 px-6 rounded-2xl font-medium hover:bg-gray-200 transition-all duration-300 disabled:opacity-70 disabled:hover:scale-100 disabled:cursor-not-allowed"
      variants={buttonVariants}
      whileHover={!isSubmitting ? "hover" : "disabled"}
      whileTap={!isSubmitting ? "tap" : "disabled"}
      animate={isSubmitting ? "disabled" : "hover"}
    >
      <span className="flex items-center justify-center gap-2">
        {isSubmitting ? (
          <>
            <motion.div 
              className="w-4 h-4 border-2 border-gray-400 border-t-black rounded-full animate-spin"
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            />
            {loadingText}
          </>
        ) : (
          <>
            {text}
            <motion.div
              animate={{ x: [0, 2, 0] }}
              transition={{ duration: 1, repeat: Infinity }}
            >
              <ArrowRightIcon />
            </motion.div>
          </>
        )}
      </span>
    </motion.button>
  );
};
